import * as common from './common';
import * as imagejs from './module/image';
import * as download from './module/download';
import * as select from './module/select';
import * as modal from './module/modal';
import * as share from './module/share';
import * as copy_album from './module/copy_album';

$(function () {

    // object-fit用　IE対策
    objectFitImages();

    // empty_box 縦いっぱいにする
    let fixparam = 50;
    $('.empty_box').height($('main').height() - $('#album_header').height() - fixparam);
    $(window).on('resize', function () {
        $('.empty_box').height('auto');
        $('.empty_box').height($('main').height() - $('#album_header').height() - fixparam);
    });

    // サムネイルトリミングオプション反映
    if (opt_thumtrim === '1') {
        $('.image_box img').css({
            'object-fit': 'contain',
            'font-family': 'object-fit: contain',
        });
    }

    // セレクト内容があれば反映
    if (typeof select_list !== 'undefined') {
        select_list.split(',').forEach(select => {
            $('#checkbox_' + select).prop('checked', true);
        });
    }

    // 写真選択を反映
    onChangeCheckbox();
    
    // チェックボックス監視
    $('input:checkbox[name="selectimg"]').on("change", function () {
        onChangeCheckbox();
    });

    // サムネイルBOXの幅を設定
    setBoxWidth();

    // オリジナルデータマーク遅延表示（スクリーンショットから外すため）
    setTimeout(function () {
        $('.download_data').addClass('display_download_data');
    }, 1000);

    // BOXの視覚効果遅延付与（スクリーンショットから外すため）
    setTimeout(function () {
        $('.image_container').css('transition', '0.5s');
    }, 2000);


    // 未作成のサムネイルを繰り返し取得試行
    //getImage();

    // 画像リストを作成してmakeImage()へ
    //makeImage_uuids();
});


// ボタンクリック関連
$(function () {
    
    // セレクト送信ボタン
    $('#sendSelectButton').on("click", function () {

        // セレクトした写真を取得
        let uuid_list = [];
        $('input:checkbox[name="selectimg"]:checked').each(function () {
            uuid_list.push($(this).val());
        });

        $('#sendSelect_modal').fadeIn();
        modal.stopScroll();
    });

    // アルバム作成（複製）ボタン
    $('#copyAlbumButton').on("click", function () {
        // タイトル挿入
        copy_title.value = title_input.value + '（コピー）';

        $('#copyAlbum_modal').fadeIn();
        modal.stopScroll();
    });

    // 共有ボタン
    $('#shareButton').on("click", function () {
        $('#share_modal').fadeIn();
        modal.stopScroll();
    });


    // すべて選択
    $('#select_all').on("click", function () {
        $('input:checkbox[name="selectimg"]').each(function () {
            $(this).prop('checked', true);
        });
        onChangeCheckbox();
    });
    // 選択を反転
    $('#select_reverse').on("click", function () {
        $('input:checkbox[name="selectimg"]').each(function () {
            if ($(this).prop('checked')) {
                $(this).prop('checked', false);
            } else {
                $(this).prop('checked', true);
            }
        });
        onChangeCheckbox();
    });
    // すべて解除
    $('#select_off, .popup_menu_close').on("click", function () {
        $('input:checkbox[name="selectimg"]').each(function () {
            $(this).prop('checked', false);
        });
        onChangeCheckbox();
    });

    // セレクトモード時、ポップアップ
    $('#selectmode_info_close_btn').on("click", function () {
        $('#selectmode_info').fadeOut();
    });

    // サムネサイズ変更ボタン
    $('.box_width_select_item').on("click", function () {
        // Cookieセット
        Cookies.set('box_width', $(this).attr('value'), { expires: 30, path: '' });
        // サイズ変更へ
        setBoxWidth();
    });

});

// BOXサイズ変更
function setBoxWidth() {
    // Cookie取得
    let box_width = Cookies.get('box_width');
    // Cookieがない場合はデフォルト値
    if (!box_width) {
        box_width = 'md';
    }
    // BOXサイズクラスを追加
    $('.image_container').each(function (index, element) {
        $(element).removeClass(function (index, className) {
            return (className.match(/\bbox_width_\S+/g) || []).join(' ');
        });
        $(element).addClass('box_width_' + box_width);
    });

    // サイズボタンにselectedクラス追加
    $('.box_width_select_item').each(function (index, element) {
        // selectedクラスを一旦すべて削除してから追加する
        $(element).removeClass('selected');
        if ($(element).attr('value') == box_width) {
            $(this).addClass('selected');
        }
    });
}

// サムネイル　クリックでスライドオープン　ロングタップでセレクト
$(function () {
    ////////////////////////////// longpress が正しく動作するための対処用
    let touchmove_flag = true; // スワイプ時回避用
    let click_flag = false; // 左クリック回避用

    $('.image_box').on("click", function () {
        click_flag = true;
    });
    $('.image_box').on("touchstart", function () {
        $(this).addClass('pointerEvents_none');
        $('#app').addClass('userSelect_none');
        touchmove_flag = true;
        click_flag = true;
    });
    $('.image_box').on("touchend", function () {
        $(this).removeClass('pointerEvents_none');
        setTimeout(function () {
            $('#app').removeClass('userSelect_none');
        }, 100);
    });
    $('.image_box').on("touchmove", function () {
        touchmove_flag = false;
    });
    //////////////////////////////

    $('.image_box').longpress(function () { // longpress ライブラリ使用
        // セレクト状態にする
        $(this).parent().find('input').prop('checked', true);
        onChangeCheckbox();
    },
        function () { // 通常クリック時

            var this_elem = this;

            // click_flag　が付くまで待つ
            setTimeout(function () {
                if (touchmove_flag && click_flag) {
                    // クリック時動作関数へ
                    imagejs.onClick_image_box(this_elem);
                }
                click_flag = false;
            }, 100);
        },
        800 // ロングタップを検知するミリ秒
    );
});

window.errorImages = [];
//window.errorImage_uuids_dones = [];
//window.makeImageTaskCount = 0;
window.isRunningTask = false;
window.retryCount = 3;
window.retryTime = 1000 * 2;

// 画像読み込みエラー時
window.tryMakeImage = function tryMakeImage(e) {

    // Loading画像に差し替え
    $(e).attr('src', mypath + 'images/loading.gif');

    // サムネのエラー時以外はスルー
    if (e.id.indexOf('thum_') === -1) return;

    const image_uuid = e.id.replace('thum_', '');
    
    // エラーイメージリストに追加
    const errorImage = errorImages.filter((errorImage) => errorImage.get('image_uuid') === image_uuid);
    if (errorImage.length === 0) {
        const errorImage = new Map();
        errorImage.set('image_uuid', image_uuid);
        errorImage.set('retry', 0);
        errorImage.set('status', '');
        errorImages.push(errorImage);
    } else {
        errorImage[0].set('status', 'error');
    }
    
    // 画像再取得
    runSetInterval();
}

function runSetInterval() {

    if (isRunningTask) return;
    isRunningTask = true;

    let runInterval = setInterval(() => {
        runReloadImage();

        if (errorImages.filter((errorImage) => errorImage.get('status') === '').length === 0) {
            clearInterval(runInterval);
            isRunningTask = false;
        }
    }, 1000);
}

// 画像再取得
function runReloadImage() {

    //////////////////////// リストから1つ取り出して実行
    const errorImage = errorImages.filter((errorImage) => errorImage.get('status') !== 'done' && errorImage.get('retry') < retryCount);

    if (errorImage.length === 0) return;

    errorImage[0].set('retry', errorImage[0].get('retry') + 1);
    errorImage[0].set('status', 'running');

    setTimeout(() => {

        reloadImage(errorImage[0].get('image_uuid'));

        errorImage[0].set('status', 'done');

    }, retryTime * errorImage[0].get('retry'));
}

// 画像再取得
function reloadImage(image_uuid) {
    
    // サムネイル画像　挿入
    $('#thum_' + image_uuid).attr('src', $('#thum_' + image_uuid).attr('data-src'));

    // プレビュー（スライド）画像　挿入
    $('#slide_' + image_uuid + '_pc').attr('src', $('#slide_' + image_uuid + '_pc').attr('data-src'));
    $('#slide_' + image_uuid + '_sp').attr('src', $('#slide_' + image_uuid + '_sp').attr('data-src'));
}

window.onChangeCheckbox = function onChangeCheckbox() {
    
    let id_list = [];

    // セレクトされた写真リストを作成
    $('input:checkbox[name="selectimg"]').each(function () {
        if ($(this).prop('checked')) {

            id_list.push($(this).val());

            // セレクトされたサムネを丸くする
            $(this).parent().prev().addClass("border_circle");
        } else {
            // セレクトされていないサムネを元の四角へ戻す
            $(this).parent().prev().removeClass("border_circle");
        }
    });
    
    if (id_list.length > 0) {
        // 1つ以上選択された状態の場合
        $('.only_selectedImage_inline').css('display', 'inline-block');
        $('.only_selectedImage').css('display', 'flex');
        $('.checkbox_btn').addClass('checkmark_active');

        // ブラウザの選択機能を無効に
        $('#image_list').addClass('userSelect_none');
    } else {
        // 1つも選択されていない場合
        $('.only_selectedImage_inline').css('display', 'none');
        $('.only_selectedImage').fadeOut();
        $('.checkmark_active').removeClass('checkmark_active');
        
        // リンクを有効に
        $('.image_box').removeClass('pointerEvents_none');
        // ブラウザの選択機能を元に戻す
        $('#image_list').removeClass('userSelect_none');
    }

    // セレクト枚数更新
    selectedCount.innerHTML = id_list.length;
}

////////////////////////////////////　Shiftキーで複数選択
$(function () {
    var checked_last = null;

    $('.checkbox_btn').on('click', function (event) {

        if (event.shiftKey && checked_last) {
            //　クリック無効（IE対策）
            event.preventDefault();

            // Shiftを押してクリックした場所は終点として処理をする
            var targets = $('.checkbox_space');
            var checked_now = this.offsetParent; //　checkbox_space（終点）

            var p1 = targets.index(checked_last); // 始点
            var p2 = targets.index(checked_now); //　終点

            //　チェックボックス要素取得
            var mycheckebox = targets.find('input:checkbox[name="selectimg"]');

            for (var i = Math.min(p1, p2); i <= Math.max(p1, p2); ++i) {
                mycheckebox.get(i).checked = mycheckebox.get(p1).checked;
            }

            // セレクト内容チェック
            onChangeCheckbox();
        } else {

            // Shiftを押さずにクリックした場所は始点として覚えておく
            checked_last = this.offsetParent; //　checkbox_space（始点）
        }
    });
});


/* function runMakeImage() {

    // console.log('makeImageTaskCount:' + makeImageTaskCount);
    // console.log('errorImages:' + errorImages.length);
    // console.log('errorThumPaths:' + errorThumPaths.length);

    // リストが空の場合はスルー
    if (errorImages.length === 0) {
        return;
    }

    // 同時実行タスク数を超えていたらスルー
    if (makeImageTaskCount >= limitTaskCount) {
        return;
    }

    let errorImage = errorImages.shift();

    // リトライの回数を超えていたらスルー
    if (errorThumPaths.filter(item => item === errorImage).length > retryCount) {
        return;
    }

    // サムネイル画像作成へ
    makeImage(errorImage);
}

// サムネイル画像作成
function makeImage(errorImage) {

    makeImageTaskCount++;

    $.ajax({
        type: 'POST',
        url: mypath + 'image/makeimage',
        data: {
            'errorImage': errorImage,
            'album_uuid': album_uuid,
        },
        dataType: 'json',
        scriptCharset: 'utf-8',
        cache: false
    })
        .then(
            function (res) {
                makeImageTaskCount--;
                runMakeImage();

                if (res['flag']) {
                    insertImage(res['image_uuid']);
                } else {
                    // エラー時
                    errorThumPaths.push(errorImage);
                }
            },
            function (XMLHttpRequest, textStatus, errorThrown) {
                makeImageTaskCount--;
                runMakeImage();

                // エラー時
                errorThumPaths.push(errorImage);
            });
}

////////////////////////////////////　サムネ挿入
function insertImage(image_uuid) {
    
    // サムネイル画像　挿入
    $('#thum_' + image_uuid).attr('src', $('#thum_' + image_uuid).attr('data-src'));

    // プレビュー（スライド）画像　挿入
    $('#slide_' + image_uuid + '_pc').attr('src', $('#slide_' + image_uuid + '_pc').attr('data-src'));
    $('#slide_' + image_uuid + '_sp').attr('src', $('#slide_' + image_uuid + '_sp').attr('data-src'));
} */